import { lazy } from 'react'

export const UpsellVariant2 = lazy(() => import('./UpsellVariant2'))
export const UpsellVariant3 = lazy(() => import('./UpsellVariant3'))
